import { render, staticRenderFns } from "./PoliticasBarragan.vue?vue&type=template&id=0519ed08&scoped=true&"
import script from "./PoliticasBarragan.vue?vue&type=script&lang=js&"
export * from "./PoliticasBarragan.vue?vue&type=script&lang=js&"
import style0 from "./PoliticasBarragan.vue?vue&type=style&index=0&id=0519ed08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0519ed08",
  null
  
)

export default component.exports